import { createI18n } from 'vue-i18n'

// Çeviri dosyalarını içeri aktarın
import en from './en.json'
import tr from './tr.json'
import de from './de.json'
import pt from './pt.json'
import fr from './fr.json'
import it from './it.json'
import zh from './zh.json'
import hi from './hi.json'
import ru from './ru.json'
import id from './id.json'

import fil from './fil.json' // Filipince çeviri

const messages = {
  en,
  tr,
  de,
  pt,
  fr,
  it,
  zh,
  hi,
  ru,
  id,
  
  fil,
}

// Kullanıcının IP'sine göre dil belirleme
async function detectLanguage() {
  try {
    const res = await fetch("https://ipapi.co/json/") // alternatif: ipinfo.io
    const data = await res.json()
    const countryCode = data.country_code // Örn: "TR", "DE", "PH"

    // Ülke → Dil kodu eşleştirme
    const map = {
      IN: 'hi',   // Hindistan
      DE: 'de',   // Almanya
     
      FR: 'fr',   // Fransa
      ID: 'id',   // Endonezya
      IT: 'it',   // İtalya
      PT: 'pt', 
      BR: 'pt',   
      RU: 'ru',   // Rusya
      TR: 'tr',   // Türkiye
      CN: 'zh',   // Çin
      HK: 'zh',
      MO: 'zh',
  TW: 'zh',
      PH: 'fil',  // Filipinler ✅
    }

    return map[countryCode] || 'en' // eşleşme yoksa İngilizce
  } catch (e) {
    return 'en'
  }
}

const savedLanguage = localStorage.getItem('language')

// i18n oluşturma
const i18n = createI18n({
  legacy: false,
  locale: savedLanguage || 'en', // başlangıçta en
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
})

// IP'den dili algıla ve ayarla
detectLanguage().then(lang => {
  i18n.global.locale.value = savedLanguage || lang
  localStorage.setItem('language', i18n.global.locale.value)
})

export default i18n
